import { Controller } from "@hotwired/stimulus"

// A text that has to be scrolled to its end before it can be confirmed
// (the data processing agreement, 08.10.2026).
//
//   data-controller="read-gate"
//   text:    the scrolling box, data-action="scroll->read-gate#check"
//   button:  the confirm button, disabled until the end was reached
//   flag:    hidden field, becomes "1" at the end -- the server refuses without it
//   seconds: hidden field, how long the page was open when confirming
//   hint:    the "scroll to the end" line, hidden once the end was reached
// A text short enough to show whole counts as read once it is on the screen.
export default class extends Controller {
  static targets = ["text", "button", "flag", "seconds", "hint"]

  connect() {
    this.opened = Date.now()
    this.reached = false
    this.check()
    this.element.addEventListener("submit", () => {
      if (this.hasSecondsTarget) this.secondsTarget.value = Math.round((Date.now() - this.opened) / 1000)
    })
  }

  check() {
    if (this.reached || !this.hasTextTarget) return
    const box = this.textTarget
    if (box.scrollTop + box.clientHeight < box.scrollHeight - 12) return
    this.reached = true
    if (this.hasFlagTarget) this.flagTarget.value = "1"
    if (this.hasButtonTarget) this.buttonTarget.disabled = false
    if (this.hasHintTarget) this.hintTarget.hidden = true
  }
}
